import { useEffect } from 'react'
import 'firebase/auth'

import { auth, firebaseAnalytics } from '../firebaseConfig'
import { clearAuth, setToken } from '../utils/auth'
import { multiFactor } from 'firebase/auth'
import { useAuthStore } from '../store/authStore'
import { sessionActions } from '../store/sessionActions'
import { setUserProperties } from 'firebase/analytics'
import { setTag } from '@sentry/react'
import { breadcrumb } from '../utils/sentry'

export const useFirebaseTokenListener = () => {
    useEffect(() => {
        //This includes sign-in, sign-out, and token refresh events.
        const unsubscribe = auth.onIdTokenChanged(async (user) => {
            // Settles 'initializing' the moment this fires at all (MD-1633), not only once a
            // token happens to change below — otherwise a cached user this callback declines to
            // set a token for (see the has2FA/isGoogleAuth/isMicrosoftAuth check further down)
            // would leave the session stuck on the initializing spinner forever.
            sessionActions.firebaseAuthStateKnown()
            if (!user) {
                console.info('[useFirebaseTokenListener] User is not authenticated')
                breadcrumb('useFirebaseTokenListener', 'User is not authenticated')
                clearAuth()
                return
            }

            try {
                const tokenResult = await user.getIdTokenResult()
                console.info('[useFirebaseTokenListener] Id token:', tokenResult)

                if (tokenResult.token === useAuthStore.getState().idToken) return

                const has2FA = multiFactor(user).enrolledFactors.length > 0
                const sign_in_provider = tokenResult.signInProvider ?? 'base'
                const isGoogleAuth = sign_in_provider === 'google.com'
                const isMicrosoftAuth = sign_in_provider === 'microsoft.com'
                breadcrumb('useFirebaseTokenListener', 'Token changed', { has2FA, tokenResult })
                console.info('[useFirebaseTokenListener] Has 2FA:', has2FA)
                console.info('[useFirebaseTokenListener] Sign in provider', sign_in_provider)

                if (!has2FA && !isGoogleAuth && !isMicrosoftAuth) return

                console.info('[useFirebaseTokenListener] Id token changed')
                setToken(tokenResult.token)
                setUserProperties(firebaseAnalytics, { auth_provider: sign_in_provider })
                setTag(`auth_provider`, sign_in_provider)
            } catch (error) {
                console.error('Error handling token change:', error)
                clearAuth()
            }
        })

        return unsubscribe
    }, [])
}
